import React, { useState } from "react"
import { VACATION_DAYS_VARIANTS } from "../../consts/modules/vacations.consts"
import Chip from "../atoms/misc/Chip.atom"
import GlassCupIcon from "../../design/assests/images/icons/glass-cup"
import useThemeContext from "../../hooks/contextConsumers/useThemeContext.hook"
import AddIcon from "@mui/icons-material/Add"
import StarIcon from "@mui/icons-material/Star"
import BeachAccessIcon from "@mui/icons-material/BeachAccess"
import ThumbUpIcon from "@mui/icons-material/ThumbUp"
import ClockIcon from "@mui/icons-material/AccessTimeFilled"
import PaidIcon from "@mui/icons-material/Paid"

const VACATION_DAY_TYPES = /** @type {const} */ ({
  BUCKET: "cubeta",
  PLUS: "dia_plus",
  EXTRA: "dia_extra",
  TAKEN: "dia_tomado",
  ACCORDED: "dia_acordado",
  APROBADOS: "dias_aprobados",
  POR_APROBAR: "dias_por_aprobar",
  PLUS_PENDIENTE_PAGO: "dia_plus_pendiente_pago",
})

/**
 * @param {VacationDayVariantChipProps} props
 */
const VacationDayVariantChip = ({
  variant = VACATION_DAYS_VARIANTS.SHORT,
  disabled = false,
  dayType,
  quantity,
  showQuantity,
  label,
  iconProps,
  className = "",
  onClick,
  hoverEffect = false,
}) => {
  const { theme } = useThemeContext()
  const [isHover, setIsHover] = useState(false)
  const VACATION_DAY_ICONS = {
    [VACATION_DAY_TYPES.BUCKET]: (
      <GlassCupIcon className="icon" {...iconProps} />
    ),
    [VACATION_DAY_TYPES.PLUS]: <AddIcon className="icon" {...iconProps} />,
    [VACATION_DAY_TYPES.EXTRA]: <StarIcon className="icon" {...iconProps} />,
    [VACATION_DAY_TYPES.TAKEN]: (
      <i {...iconProps} className="pi pi-check-circle" />
    ),
    [VACATION_DAY_TYPES.ACCORDED]: (
      <BeachAccessIcon className="icon" {...iconProps} />
    ),
    [VACATION_DAY_TYPES.APROBADOS]: <ThumbUpIcon className="icon" />,
    [VACATION_DAY_TYPES.POR_APROBAR]: <ClockIcon className="icon" />,
    [VACATION_DAY_TYPES.PLUS_PENDIENTE_PAGO]: <PaidIcon className="icon" />,
  }

  return (
    <div
      className={`inline-flex align-items-center gap-1 ${className}`}
      onMouseEnter={() => hoverEffect && setIsHover(true)} 
      onMouseLeave={() => hoverEffect && setIsHover(false)} 
    >
      <Chip
        onClick={onClick}
        className="w-fit h-fit my-auto inline-block"
        template={
          <div
            className={`vacation-day-chip-container flex ${variant}`}
            style={{ opacity: disabled ? 0.55 : isHover ? 0.75 : 1}}
          >
            <div className={`vacation-day-chip-icon ${dayType}`}>
              {VACATION_DAY_ICONS[dayType]}{" "}
              {showQuantity && variant !== VACATION_DAYS_VARIANTS.SHORT && (
                <span className="vacation-day-chip-quantity">{quantity}</span>
              )}
            </div>
          </div>
        }
      />
      {label ?
        <div>{label}</div>
      : null}
    </div>
  )
}

export default VacationDayVariantChip

/**
 * @typedef {Object} VacationDayVariantChipProps
 * @property {VACATION_DAYS_VARIANTS[keyof VACATION_DAYS_VARIANTS]} [variant] - Variante del chip, puede ser 'short', 'medium' o 'large'.
 * @property {boolean} [disabled] - Si el chip está deshabilitado.
 * @property {VACATION_DAY_TYPES[keyof VACATION_DAY_TYPES]} dayType - Tipo de día de vacaciones.
 * @property {number} [quantity] - Cantidad de días.
 * @property {boolean} [showQuantity] - Si se debe mostrar la cantidad de días.
 * @property {string} [label] - Etiqueta opcional para mostrar junto al chip.
 * @property {Object} [iconProps] - Propiedades adicionales para el icono.
 * @property {string} [className] - Clases adicionales para el contenedor.
 * @property {() => void} [onClick] - Función a ejecutar al hacer clic en el chip.
 */
